/*

? First, let's import the interface that will describe the shape of our chat object.

*/

import StateInterface from "../state-interface";

/*

& Now let's describe an initial state for the chat object. This is the state that will be used when the app first fires up. Think of it like a placeholder.

*/

export const feature_discovery_tracker: StateInterface["feature_discovery_tracker"] = {
    _id: "",
    profile: {
        is_business_profile: false,
        user_id: "",
        business_profile_id: "",
    },
    created_by: {
        is_business_profile: false,
        user_id: "",
        business_profile_id: "",
    },
    created_at: "",
    broadcast: {
        viewed: false,
        viewed_at: "",
        skipped: false,
    },
};
